/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Mobility_DietInputs */

const en_portal_goal_mobility_diet = /** @type {(inputs: Portal_Goal_Mobility_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No change, unless you want one`)
};

const pl_portal_goal_mobility_diet = /** @type {(inputs: Portal_Goal_Mobility_DietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez zmian, chyba że chcesz`)
};

/**
* | output |
* | --- |
* | "No change, unless you want one" |
*
* @param {Portal_Goal_Mobility_DietInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_mobility_diet = /** @type {((inputs?: Portal_Goal_Mobility_DietInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Mobility_DietInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_mobility_diet(inputs)
	return en_portal_goal_mobility_diet(inputs)
});